import React, { useState, useEffect } from 'react';
import { Calendar } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './Calendrier.css';

import ReceiptPrint from './ReceiptPrint';

import localizer from './localizer';
import Toolbar from './Toolbar';
import EventFormModal from './EventFormModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faTrash, faPrint, faPen } from '@fortawesome/free-solid-svg-icons';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Swal from 'sweetalert2';

const Calendrier = () => {
  const [events, setEvents] = useState([]);
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentView, setCurrentView] = useState('month');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clickedDate, setClickedDate] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [eventToEdit, setEventToEdit] = useState(null);

  const fetchEvents = async () => {
    try {
      setIsLoading(true);
      const res = await fetch('https://ccjab.pro/api/evenements.php');
      const data = await res.json();
  
      const formatted = data.map((e) => ({
        ...e,
        id: e.id,
        title: e.titre,
        start: new Date(e.debut_date),
        end: new Date(e.fin_date),
        couleur: e.couleur || '#007bff',
        allDay: false,
      }));
  
      setEvents(formatted);
      toast.success("Événements chargés !", { toastId: 'events_loaded' });
    } catch (err) {
      toast.error("Erreur lors du chargement.");
    } finally {
      setIsLoading(false);
    }
  };
  
  

  useEffect(() => {
    fetchEvents();
  }, []);
  
  

  const filteredEvents = events.filter((event) =>
    event.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAddEvent = (event) => {
    const newEvent = {
      title: event.titre,
      start: new Date(`${event.debutDate}T${event.debutHeure}`),
      end: new Date(`${event.finDate}T${event.finHeure}`),
      couleur: event.couleur || '#007bff',
      ...event
    };

    setEvents((prev) => [...prev, newEvent]);
    toast.success("Événement ajouté !");
  };

  const handleUpdateEvent = (updatedEvent) => {
    setEvents((prevEvents) =>
      prevEvents.map((evt) =>
        evt.id === updatedEvent.id ? { ...evt, ...updatedEvent } : evt
      )
    );
    toast.success("Évènement mis à jour !");
  };
  
  const handlePrint = () => {
    const content = document.getElementById('recu-a-imprimer');
  
    if (!content) {
      toast.error('❌ Le reçu est introuvable.');
      return;
    }
  
    const printWindow = window.open('', '', 'width=800,height=600');
  
    // Évite tout crash s’il y a un blocage popup
    if (!printWindow) {
      toast.error('❌ La fenêtre d’impression a été bloquée.');
      return;
    }
  
    printWindow.document.write('<html><head><title></title>');
    printWindow.document.write('<style>body { font-family: sans-serif; padding: 20px; }</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(content.outerHTML);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
  
    // ✅ Attends que le contenu soit chargé avant impression
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    };
  };  
  

  const handleDateClick = (slotInfo) => {
    setSelectedDate(slotInfo.start);
    setShowModal(true);
  };

  const handleEventClick = (event) => {
    setSelectedEvent(event);
  };

  // Supprimer l’événement
const handleDeleteEvent = async () => {
  if (!selectedEvent) return;

  const result = await Swal.fire({
    title: 'Supprimer cet événement ?',
    text: 'Cette action est irréversible.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Oui, supprimer',
    cancelButtonText: 'Annuler'
  });

  if (result.isConfirmed) {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      const userId = user?.id;

      if (!userId) {
        Swal.fire('Erreur', 'Utilisateur non authentifié.', 'error');
        return;
      }

      const res = await fetch(`https://ccjab.pro/api/evenements.php?id=${selectedEvent.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-USER-ID': userId
        }
      });

      if (res.ok) {
        // Mise à jour locale de la liste des événements
        setEvents((prev) => prev.filter((e) => e.id !== selectedEvent.id));
        setSelectedEvent(null);

        Swal.fire({
          icon: 'success',
          title: 'Supprimé !',
          text: 'L’événement a bien été supprimé.',
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        const data = await res.json();
        console.error("❌ Erreur suppression :", data);
        Swal.fire('Erreur', data.message || 'Erreur lors de la suppression.', 'error');
      }
    } catch (err) {
      console.error('🚨 Erreur serveur :', err);
      Swal.fire('Erreur serveur', 'Impossible de supprimer pour le moment.', 'error');
    }
  }
};

  
  

  // ✅ Couleur douce + blink si en cours
  const hexToRgba = (hex, alpha = 0.6) => {
    if (!hex.startsWith('#') || hex.length !== 7) return `rgba(0,123,255,${alpha})`;
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const getTextColor = (hex) => {
    if (!hex || hex.length !== 7) return '#000';
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 160 ? '#000' : '#fff';
  };

  const eventStyleGetter = (event) => {
    const now = new Date();
    const start = new Date(event.start);
    const end = new Date(event.end);
    const bgColor = hexToRgba(event.couleur, 0.6);
    const textColor = getTextColor(event.couleur);
    const isNow = now >= start && now <= end;

    return {
      style: {
        backgroundColor: bgColor,
        borderRadius: '8px',
        padding: '4px',
        fontWeight: 700,
        fontSize: '14px',
        color: textColor,
        textShadow: textColor === '#fff' ? '1px 1px 2px rgba(0,0,0,0.3)' : 'none',
        border: '1px solid #ccc',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        animation: isNow ? 'blink 1s infinite' : 'none'
      }
    };
  };

  return (
    <div className="calendrier-wrapper">
      <ToastContainer />
      <div className={`calendrier-container ${isMenuOpen ? '' : 'full'}`}>
        <Calendar
          localizer={localizer}
          culture="fr"
          events={filteredEvents}
          startAccessor="start"
          endAccessor="end"
          selectable
          onSelectSlot={handleDateClick}
          onSelectEvent={handleEventClick}
          longPressThreshold={1}
          view={currentView}
          onView={setCurrentView}
          date={currentDate}
          onNavigate={setCurrentDate}
          components={{
            toolbar: (props) => (
              <Toolbar
                {...props}
                onToggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                onAddButtonClick={() => {
                  setClickedDate(new Date());
                  setEditMode(false);
                  setEventToEdit(null);
                  setIsModalOpen(true);
                }}
              />
            )
          }}
        
          views={['month', 'day', 'agenda']}
          defaultView="month"
          style={{ height: 600 }}
          eventPropGetter={eventStyleGetter}
          messages={{
            next: 'Suivant',
            previous: 'Précédent',
            today: "Aujourd'hui",
            month: 'Mois',
            week: 'Semaine',
            day: 'Jour',
            agenda: 'Agenda',
            date: 'Date',
            time: 'Heure',
            event: 'Événement',
            allDay: 'Toute la journée',
            noEventsInRange: 'Aucun événement prévu sur cette période.',
            showMore: (total) => `+ ${total} de plus`,
          }}
        />

        

        <EventFormModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setEditMode(false);
            setEventToEdit(null);
            fetchEvents(); // Recharge toujours les événements à la fermeture
          }}
          onAddEvent={() => {
            fetchEvents(); // Recharge après ajout
            setIsModalOpen(false);
            setEditMode(false);
            setEventToEdit(null);
          }}
          onUpdateEvent={() => {
            fetchEvents(); // Recharge après modif
            setIsModalOpen(false);
            setEditMode(false);
            setEventToEdit(null);
          }}
          clickedDate={clickedDate}
          editMode={editMode}
          eventToEdit={eventToEdit}
        />




        {selectedEvent && (
          <div className="event-details-modal">
            <div className="modal-card">
              <h2 className="event-title">Détails</h2>
              <div className="event-details-grid">
                {(() => {
                  const now = new Date();
                  const start = new Date(selectedEvent.start);
                  const end = new Date(selectedEvent.end);
                  let statut = '';
                  let color = '';

                  if (now < start) {
                    statut = 'À venir';
                    color = '#3498db';
                  } else if (now >= start && now <= end) {
                    statut = 'En cours';
                    color = '#f39c12';
                  } else {
                    statut = 'Terminé';
                    color = '#95a5a6';
                  }

                  return (
                    <div style={{
                      padding: '10px',
                      fontWeight: 'bold',
                      color: 'white',
                      backgroundColor: color,
                      borderRadius: '6px',
                      textAlign: 'center',
                      gridColumn: '1 / -1'
                    }}>
                      Statut : {statut}
                    </div>
                  );
                })()}

                <div><strong>Client :</strong> {selectedEvent.nom_prenom || '—'}</div>
                <div><strong>Contact :</strong> {selectedEvent.contact || '—'}</div>
                <div><strong>Salles :</strong> {selectedEvent.noms_salles?.join(', ') || '—'}</div>
                <div><strong>Catégorie :</strong> {selectedEvent.categorie_nom || '—'}</div>
                <div><strong>Type :</strong> {selectedEvent.type_nom || '—'}</div>

                <div>
                  <strong>Date début :</strong>{" "}
                  {new Date(selectedEvent.start).toLocaleString('fr-FR', {
                    weekday: 'long', day: '2-digit', month: 'long', year: 'numeric',
                    hour: '2-digit', minute: '2-digit'
                  })}
                </div>

                <div>
                  <strong>Date fin :</strong>{" "}
                  {new Date(selectedEvent.end).toLocaleString('fr-FR', {
                    weekday: 'long', day: '2-digit', month: 'long', year: 'numeric',
                    hour: '2-digit', minute: '2-digit'
                  })}
                </div>

                <div>
                  <strong>Date de création :</strong>{" "}
                  {selectedEvent.date_creation
                    ? new Date(selectedEvent.date_creation).toLocaleString('fr-FR', {
                        weekday: 'long',
                        day: '2-digit',
                        month: 'long',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })
                    : '—'}
                </div>


                <div><strong>Total à payer :</strong> {selectedEvent.total_payer ? `${selectedEvent.total_payer} FCFA` : '—'}</div>

                {[1, 2, 3].map(num => {
                  const value = selectedEvent[`tranche_${num}`];
                  return value > 0 ? <div key={num}><strong>Tranche {num} :</strong> {value} FCFA</div> : null;
                })}

                {(() => {
                  const totalVerse = (selectedEvent.tranche_1 || 0) + (selectedEvent.tranche_2 || 0) + (selectedEvent.tranche_3 || 0);
                  const totalPayer = selectedEvent.total_payer || 0;
                  const reste = totalPayer - totalVerse;

                  return (
                    <>
                      <div><strong>Total versé :</strong> {totalVerse} FCFA</div>
                      {reste > 0 ? (
                        <div style={{ color: 'red', fontWeight: 'bold' }}>
                          Reste à payer : {reste} FCFA
                        </div>
                      ) : (
                        <div style={{ color: 'green', fontWeight: 'bold' }}>
                          ✅ Paiement soldé
                        </div>
                      )}
                    </>
                  );
                })()}

                <div><strong>Note :</strong> {selectedEvent.note || '—'}</div>
                <div><strong>Agent :</strong> {selectedEvent.agent_nom || '—'}</div>
                <div><strong>Créateur :</strong> {selectedEvent.createur_nom || '—'}</div>
              </div>

              <div className="event-actions">
                <button className="btn blue" onClick={() => setSelectedEvent(null)}>
                  <FontAwesomeIcon icon={faTimes} /> Fermer
                </button>

                <button className="btn red" onClick={handleDeleteEvent}>
                  <FontAwesomeIcon icon={faTrash} /> Supprimer
                </button>

                <button className="btn yellow" onClick={handlePrint}>
                  <FontAwesomeIcon icon={faPrint} /> Imprimer
                </button>

                <button className="btn green" onClick={() => {
                  setEventToEdit(selectedEvent);
                  setEditMode(true);
                  setIsModalOpen(true);
                  setSelectedEvent(null);
                }}>
                  <FontAwesomeIcon icon={faPen} /> Modifier
                </button>
              </div>

              {/* ✅ Composant du reçu, masqué mais dans le DOM */}
              <div style={{ display: 'none' }}>
                <ReceiptPrint event={selectedEvent} />
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default Calendrier;